import { Observable, firstValueFrom } from "rxjs";
import HttpService from "./HttpService";
import { url } from "./APIEndPoints";
import {
  AuthService,
  buildParamString,
  IAPIResponse,
} from "@mindmemobile/mm-shared-global";
import {
  IAPIPaymentReceiptDetailsModel,
  IAPIFindAccountResponseModel,
  IAPIGeneralSettingsModel,
} from "../interfaces/PaymentSettingsInterfaces";
import { IAPIApplicationSettingsModel } from "../interfaces";


class AccountService {
  private httpService: HttpService;
  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL,
    );
  }

  getGeneralSettings(
    accountId: string,
  ): Observable<IAPIResponse<IAPIGeneralSettingsModel>> {
    const params: string = buildParamString({
      accountId: accountId,
    });
    return this.httpService.get<IAPIResponse<IAPIGeneralSettingsModel>>(
      url.getGeneralSettings,
      params,
    );
  }

  updateGeneralSettings(
    data: IAPIGeneralSettingsModel,
  ): Observable<IAPIResponse<boolean>> {
    return this.httpService.put<IAPIResponse<boolean>>(
      url.updateGeneralSettings,
      data,
    );
  }

  findAccount(
    subAccountId: string,
    parentAccountId: string,
    mindmeUserId?: string,
  ): Observable<IAPIResponse<IAPIFindAccountResponseModel>> {
    const params: string = buildParamString({
      subAccountId: subAccountId,
      parentAccountId: parentAccountId,
      mindmeUserId: mindmeUserId,
    });
    return this.httpService.get<IAPIResponse<IAPIFindAccountResponseModel>>(
      url.findAccount,
      params,
    );
  }

  getApplicationSettings(): Observable<
    IAPIResponse<IAPIApplicationSettingsModel>
  > {
    return this.httpService.get<IAPIResponse<IAPIApplicationSettingsModel>>(
      url.getApplicationSettings,
      undefined,
    );
  }

}
export default new AccountService();
